<template>
  <div class="">
    <loading :loading="loading" />
    <md-table v-if="!loading">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Template equipamentos</h1>
        </div>
        <div class="md-toolbar-section-end">
          <router-link :to="{ name: 'EquipamentoTemplateCriar' }">
            <md-button class="md-primary md-raised"> Criar Template </md-button>
          </router-link>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Descrição</md-table-head>
        <md-table-head>Criado em</md-table-head>
        <md-table-head>Ação</md-table-head>
      </md-table-row>
      <md-table-row
        v-for="template in templates"
        :key="template.id"
        class="pt-2 pb-2"
      >
        <md-table-cell>{{ template.descricao }}</md-table-cell>
        <md-table-cell>
          {{ formatDate(template.criadoEm) }}
        </md-table-cell>
        <md-table-cell>
          <md-button
            class="md-raised md-primary"
            @click="() => pushEditar(template.id)"
          >
            Editar
          </md-button>
          <md-button
            class="md-raised md-accent"
            @click="() => (deleteObj = { ...template })"
          >
            Deletar
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm
      :md-backdrop="true"
      :md-active="showDialogDelete"
      md-title="Tem certeza?"
      md-content="Deseja realmente remover o template?"
      md-confirm-text="remover"
      md-cancel-text="cancelar"
      @md-confirm="() => removeTempalate()"
      @md-cancel="() => (deleteObj = null)"
    />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue'
import { formatDate } from '@/utils/transform'

import http from '../../utils/http'

export default {
  name: 'EquipamentoTemplateIndex',
  components: { Loading },
  data() {
    return {
      loading: true,
      deleteObj: null,
      templates: [],
    }
  },
  computed: {
    showDialogDelete() {
      return this.deleteObj !== null
    },
  },
  async beforeMount() {
    await this.searchTemplates()
  },
  methods: {
    formatDate,
    async searchTemplates() {
      this.loading = true

      const response = await http.get(`template-equipamento`)

      this.templates = response.templates

      this.loading = false
    },
    async removeTempalate() {
      await http.delete(`template-equipamento`, this.deleteObj.id)

      await this.searchTemplates()

      this.deleteObj = null
    },
    pushEditar(id) {
      this.$router.push({
        name: 'EquipamentoTemplateEditar',
        params: {
          templateId: id,
        },
      })
    },
  },
}
</script>
